import TextField from '@mui/material/TextField';
import {useField, useFormikContext} from 'formik';
import PropTypes from 'prop-types';
import {NumericFormat} from 'react-number-format';
import {UiWiseFieldFormat} from 'shared/constants/UiWiseConst';

const AppNumberField = ({pattern = '', prefix, format, readonly, ...props}) => {
  const [field, meta] = useField(props.name);
  const {setFieldValue} = useFormikContext();

  const errorText = meta.error && meta.touched ? meta.error : '';

  // Calculate decimals from pattern (e.g., "9.00" -> 2)
  const [, decimals = ''] = pattern.split('.');
  const decimalScale = decimals.length;

  return (
    <NumericFormat
      fullWidth
      {...props}
      customInput={TextField}
      value={field.value ?? ''}
      prefix={prefix}
      thousandSeparator={format === UiWiseFieldFormat.CURRENCY}
      allowNegative={false}
      decimalScale={decimalScale}
      fixedDecimalScale={decimalScale > 0}
      valueIsNumericString
      helperText={errorText}
      error={!!errorText}
      onValueChange={(v) => setFieldValue(field.name, v.floatValue ?? 0)}
      InputProps={{
        readOnly: readonly,
      }}
    />
  );
};

AppNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,

  pattern: PropTypes.string,
  prefix: PropTypes.string,
  format: PropTypes.oneOf(Object.values(UiWiseFieldFormat)),
  readonly: PropTypes.bool,
};

export default AppNumberField;
